import { useCallback, useEffect } from 'react';
import { CACHE_TTL, isCacheValid } from '@/utils/cache';
import { useRegieStore } from '@/zustand';
import useEncaisseStore from '@/zustand/accueil/useEncaisseStore';

/**
 * Hook pour récupérer les données d'encaisse avec cache automatique
 * Vérifie le cache à chaque utilisation et fetch si nécessaire
 */
const useEncaisseData = () => {
  const regieId = useRegieStore((state) => state.regie?.identifiant);

  const encaisse = useEncaisseStore((state) => state.data);
  const loading = useEncaisseStore((state) => state.loading);
  const error = useEncaisseStore((state) => state.error);
  const cache = useEncaisseStore((state) => state.cache);
  const fetch = useEncaisseStore((state) => state.fetch);

  // Vérification du cache à chaque utilisation du hook
  useEffect(() => {
    if (regieId && !isCacheValid(cache.timestamp, CACHE_TTL.ENCAISSE, cache.regieId, regieId)) {
      fetch(regieId);
    }
  }, [regieId, cache.timestamp, cache.regieId, fetch]);

  // Fonction pour forcer un refresh manuel
  const refresh = useCallback(() => {
    if (regieId) {
      fetch(regieId, true);
    }
  }, [regieId, fetch]);

  return {
    encaisse,
    loading,
    error,
    refresh,
  };
};

export default useEncaisseData;
